var nCustom = {
    vars: {
        focused: $("body"),
        lastFocused: $("body")
    },
    funcs: {
        initPageFuncs: function() {
            $.addToWishList({
                class: "wishlist_toggle",
                textclass: "wishlist_text",
                htmlon: '<i class="fas fa-star" aria-hidden="true"></i>',
                htmloff: '<i class="far fa-star" aria-hidden="true"></i> Wishlist',
                tooltip_css: "whltooltips",
                imageon: "",
                imageoff: ""
            }), $.initSearchField({
                result_header: '<ul class="nav nav-list">',
                result_body: '<li><a href="##url##" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
                result_footer: "</ul>",
                category_header: '<ul class="nav nav-list">',
                category_body: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
                category_footer: "</ul>"
            })
        },
        checkValidQty: function() {
            var t = 0;
            return $("#multiitemadd :input").each(function() {
                $(this).attr("id").match(/^qty/) && $(this).val() > 0 && (t = 1)
            }), 0 != t || ($.nPopupBox("Please specify a quantity before adding to cart"), !1)
        },
        updateFocused: function() {
            nCustom.vars.lastFocused = nCustom.vars.focused
        },
        popupFocus: function() {
            var t = document.getElementById("npopupDesc"),
                e = new MutationObserver(function(e) {
                    e.forEach(function(e) {
                        e.addedNodes[0] ? (nCustom.funcs.updateFocused(), $(t).attr("tabindex", "-1").trigger("focus")) : ($(t).attr("tabindex", "").trigger("focus"), $(nCustom.vars.lastFocused).trigger("focus"))
                    })
                });
            t && e.observe(t, {
                childList: !0
            })
        },
        buttonLoading: function() {
            var t = $(this).attr("data-loading-text"),
                e = $(this).html();
            $(this).html(t).addClass("disabled").prop("disabled", !0);
            var a = this;
            setTimeout(function() {
                $(a).html(e).removeClass("disabled").prop("disabled", !1)
            }, 3e3)
        },
        windowPopup: function(t, e, a) {
            var o = screen.width / 2 - e / 2,
                s = screen.height / 2 - a / 2;
            window.open(t, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + e + ",height=" + a + ",top=" + s + ",left=" + o)
        },
        classToggle: function(t, e, a) {
            a && ("add" == a ? $(t).addClass(e) : $(t).removeClass(e))
        }
    }
};
$(document).ready(function() {
    nCustom.funcs.initPageFuncs(), nCustom.funcs.popupFocus(), $(".datepicker").datepicker({
        dateFormat: "dd/mm/yy"
    }), $(".carousel").carousel(), $('[data-toggle="tooltip"]').tooltip()
}), $(document).on("focusin", function() {
    nCustom.vars.focused = document.activeElement
}), $(document).on("click", ".btn-loads", nCustom.funcs.buttonLoading), $(".js-social-share").on("click", function(t) {
    t.preventDefault(), nCustom.funcs.windowPopup($(this).attr("href"), 500, 300)
}), $(".nToggleMenu").on("click", function() {
    var t = $(this).attr("data-target");
    $(t).slideToggle()
}), $("#cart_items").on("click", "[data-body-add]", function(t) {
    t.preventDefault(), nCustom.funcs.classToggle("body", $(this).attr("data-body-add"), "add")
}), $("#cart_items").on("click", "[data-body-remove]", function(t) {
    t.preventDefault(), nCustom.funcs.classToggle("body", $(this).attr("data-body-remove"), "remove")
}), $("#_jstl__buying_options").on("click", ".js-notifymodal-in-stock", function(t) {
    t.preventDefault();
    var e = $(this).attr("data-sku"),
        a = $("#notifymodal .checkbox"),
        o = $("#notifymodal .terms_box"),
        s = $("#notifymodal .checkbox .help-block");
    return $.isChecked(o) ? (a.removeClass("has-error"), s.addClass("hidden"), $("#notifymodal").modal("hide"), $.addNotifyBackInStock(e, ""), o.attr("checked", !1), !0) : (a.addClass("has-error"), s.removeClass("hidden"), !1)
}), $(".multi-add").on("click", function() {
    if (nCustom.funcs.checkValidQty()) return $.addMultipleCartItems("multiitemadd"), !1
}), $("body").on("click", ".thumb-slide-cart-trigger", function() {
    $(".npopup").addClass("slide-cart-no-popup"), setTimeout(function() {
        $("#sidebar-cart.dropdown-menu").addClass("show"), $("body").addClass("slide-cart-open")
    }, 3e3)
}), $("#multi-slide-cart-trigger").click(function() {
    $(".npopup").addClass("slide-cart-no-popup"), setTimeout(function() {
        $("#sidebar-cart.dropdown-menu").addClass("show"), $("body").addClass("slide-cart-open")
    }, 3e3)
}), $(".slide-cart-trigger").click(function() {
    $("#sidebar-cart.dropdown-menu").addClass("show"), $("body").addClass("slide-cart-open")
}), $(".close-cart").click(function() {
    $("#sidebar-cart.dropdown-menu").removeClass("show"), $("body").removeClass("slide-cart-open"), $(".npopup").hide(), $(".npopup").removeClass("slide-cart-no-popup")
}),$(document).ready(function() {
      setTimeout(function() {
        $(".BIS_trigger").show();
      }, 3000);
}),$(".BIS_trigger").click(function() {
        $('.sm-pop-up-trigger').click();
        setTimeout(function() {
          document.getElementsByClassName("sm-pop-up-container")[0].style.display = "none";
        }, 50);
        setTimeout(function() {
          document.getElementsByClassName("sm-pop-up-container")[0].style.display = "flex";
        }, 1100);
    });
/*
document.getElementById("all_accept").addEventListener('click', () => window.clarity('consent'));
document.getElementById("essential_accept").addEventListener('click', () => window.clarity('consent'));
*/

var userSelection = document.getElementsByClassName('Compliance-cs-accept-btn');

for(var i = 0; i < userSelection.length; i++) {
  (function(index) {
    userSelection[index].addEventListener('click', () => window.clarity('consent'))
  })(i);
}